import React, { useEffect } from "react";
import styles from "../applicationSection/applicationSection.module.scss";
import Application from "../../components/application/Application";
import EasySteps from "../../components/easySteps/EasySteps";
import CommonQuestions from "../../components/commonQuestions/CommonQuestions";
import Contact from "../../components/contact/Contact";
import Footer from "../footer/Footer";
import ServicesProvided from "../../components/reusable/servicesProvided/ServicesProvided";
import Navbar from "../../components/navbar/Navbar";


const data = [
  {
    id: 1,
    question: "What is the difference between server-side and client-side rendering?",
    answer:
      "A domain is your unique identity on the internet. It helps user to find out your website or application easily.",
  },
  {
    id: 2,
    question: "How do I choose between AWS, Azure, or GCP?",
    answer:
      "A domain is your unique identity on the internet. It helps user to find out your website or application easily.",
  },
  {
    id: 3,
    question: "Can I deploy my app using Docker?",
    answer:
      "A domain is your unique identity on the internet. It helps user to find out your website or application easily.",
  },
  {
    id: 4,
    question: "What security measures should I take when setting up a server?",
    answer:
      "A domain is your unique identity on the internet. It helps user to find out your website or application easily.",
  },
];

const ApplicationSection = () => {

    useEffect(() => {
      const section = document.getElementById("services");
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, []);  

  return (
    <div className={styles.container}>
      <Navbar/>
      <Application id='services'/>
      <ServicesProvided />
      <EasySteps />
      <CommonQuestions questioData={data} />
      <Contact />
      <Footer />
    </div>
  );
};

export default ApplicationSection;
